import { useNavigate, useLocation } from 'react-router-dom';

export const useCommonNavigation = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    // Determine if user is a client or midwife based on the current route
    const isClient = pathname.startsWith('/client');
    
    return {
        goToClients: () => navigate("/midwife/clients"),
        goToDashboard: () => navigate(isClient ? "/client" : "/midwife"),
        goToCharting: (clientId) => navigate(`/charting/${clientId}`),
        goToAddClient: () => navigate("/midwife/clients/new"),
        goToClientChart: (clientId) => navigate(`/charting/${clientId}`),
        goToMyChart: () => navigate("/client/chart"),
        goBack: () => navigate(-1)
    };
}; 